/** Доступы: личные записи и общая — одна на нескольких человек. */

import { useEffect, useState } from 'react'
import { api } from '../api'
import type { Account } from '../api'

export function Accounts() {
  const [accounts, setAccounts] = useState<Account[] | null>(null)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [shared, setShared] = useState(true)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [forbidden, setForbidden] = useState(false)

  const load = () => {
    api
      .users()
      .then((data) => setAccounts(data.items))
      // Раздел виден только хозяину сервера: под общим входом его быть не должно.
      .catch(() => setForbidden(true))
  }

  useEffect(load, [])

  const create = async (event: React.FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      await api.createUser(username.trim(), password, shared)
      setUsername('')
      setPassword('')
      load()
    } catch (exc) {
      setError(describe(exc))
    } finally {
      setBusy(false)
    }
  }

  const remove = async (account: Account) => {
    const warning =
      `Закрыть доступ «${account.username}»?\n\n` +
      'Вместе с записью пропадут её полка, выписки и места чтения. Книги останутся.'
    if (!window.confirm(warning)) return
    try {
      await api.deleteUser(account.id)
      load()
    } catch (exc) {
      setError(describe(exc))
    }
  }

  if (forbidden) return null

  return (
    <section>
      <h3>Доступы</h3>

      {accounts === null ? (
        <p className="dim">Загрузка…</p>
      ) : (
        <table className="accounts">
          <thead>
            <tr>
              <th>Имя</th>
              <th>Вид</th>
              <th>Читателей</th>
              <th>Книг в чтении</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {accounts.map((account) => (
              <tr key={account.id}>
                <td>{account.username}</td>
                <td>
                  {account.is_owner ? 'хозяин' : account.shared ? 'общая' : 'личная'}
                </td>
                <td>{account.shared ? account.devices || '—' : '—'}</td>
                <td>{account.books || '—'}</td>
                <td>
                  {!account.is_owner && (
                    <button className="btn btn--ghost" onClick={() => void remove(account)}>
                      Закрыть доступ
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <form className="accounts__form" onSubmit={create}>
        <input
          type="text"
          value={username}
          placeholder="Имя для входа"
          autoComplete="off"
          onChange={(event) => setUsername(event.target.value)}
        />
        <input
          type="password"
          value={password}
          placeholder="Пароль, не короче 12 знаков"
          autoComplete="new-password"
          onChange={(event) => setPassword(event.target.value)}
        />
        <label className="accounts__kind">
          <input
            type="checkbox"
            checked={shared}
            onChange={(event) => setShared(event.target.checked)}
          />
          Общая
        </label>
        <button
          className="btn btn--primary"
          disabled={busy || username.trim().length < 3 || password.length < 12}
        >
          Завести
        </button>
      </form>

      <p className="dim accounts__hint">
        <b>Общая</b> — один вход на нескольких человек. Библиотека у всех одна, но полка,
        выписки и место чтения у каждого устройства свои: чтение разных людей не
        перемешивается. Синхронизации между устройствами под такой записью нет.
        <br />
        <b>Личная</b> — чтение хранится на сервере и продолжается на любом вашем устройстве.
      </p>
      {error && <p className="error">{error}</p>}
    </section>
  )
}

function describe(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message)
  }
  return 'Не удалось выполнить'
}
